module.exports = __webpack_public_path__ + "static/media/image-2.f21890ca.jpg";